module.exports = __webpack_public_path__ + "img/logo.b3d38e09.png";